<template>
  <div>
    <app-sidebar-item :data-title="$t('message.sidebar.message.overview')"
                      data-link="/admin/visao-geral"
                      data-icon="mdi-home-outline">
    </app-sidebar-item>

    <app-sidebar-item :data-title="$t('message.sidebar.message.partners')"
                      :data-link="redirectUtils.mountUrl('/new/admin/parceiros')"
                      data-icon="mdi-account-multiple">
    </app-sidebar-item>

    <app-sidebar-item :data-title="$t('message.sidebar.message.dataOfTheDay')"
                      :data-link="redirectUtils.mountUrl('/new/admin/dados')"
                      data-icon="mdi-calendar">
    </app-sidebar-item>

    <app-sidebar-item :data-title="$t('message.sidebar.message.establishments')"
                      :data-link="redirectUtils.mountUrl('/new/admin/estabelecimentos')"
                      data-icon="mdi-store">
    </app-sidebar-item>

    <app-sidebar-item :data-title="$t('message.sidebar.message.registrations')"
                      data-link="/admin/cadastros"
                      :disabled="!canReadClientsdata"
                      data-icon="mdi-account-outline">
    </app-sidebar-item>

    <!-- <app-sidebar-item :data-title="$t('message.sidebar.message.tag')"
                      :data-link="redirectUtils.mountUrl('/new/admin/tag')"
                      data-icon="mdi-code-tags"></app-sidebar-item>

    <app-sidebar-item :data-title="$t('message.sidebar.message.monitoring')"
                      :data-link="redirectUtils.mountUrl('/new/admin/monitoramento')"
                      data-icon="mdi-information-outline"></app-sidebar-item> -->

    <app-sidebar-item :data-title="$t('message.sidebar.message.termsOfUse')"
                      :data-link="redirectUtils.mountUrl('/new/admin/termos-de-uso')"
                      data-icon="mdi-file">
    </app-sidebar-item>

    <app-sidebar-item :data-title="$t('message.sidebar.message.marketingPlans')"
                      data-icon="mdi-calendar"
                      @click="openMarketingPlanModal"></app-sidebar-item>

    <sidebar-toggle :title="$t('message.sidebar.message.users')"
                    icon="mdi-account-group">
      <app-sidebar-item :data-title="$t('message.sidebar.message.users')"
                      :data-link="redirectUtils.mountUrl('/new/admin/usuarios/administradores')">
      </app-sidebar-item>
      <app-sidebar-item :data-title="$t('message.sidebar.message.users')"
                      :data-link="redirectUtils.mountUrl('/new/admin/usuarios/geral')">
      </app-sidebar-item>                      
    </sidebar-toggle>

    <app-sidebar-item :data-title="$t('message.sidebar.message.apsManagement')"
                      :data-link="redirectUtils.mountUrl('/new/admin/aparelhos')"                      
                      data-icon="mdi-access-point">
    </app-sidebar-item>

    <app-sidebar-item :data-title="$t('message.sidebar.message.twilioAccounts')"
                      :data-link="redirectUtils.mountUrl('/new/admin/contas-twilio')"
                      data-icon="mdi-account-group"></app-sidebar-item>

    <marketing-plan-modal v-model="showingMarketingPlanModal"
                          manage />

  </div>
</template>

<script>
import SidebarToggle from "@components/generic/sidebar/toggle/SidebarToggle";
import MarketingPlanModal from "@components/modules/marketing/plan/modal/MarketingPlanModal";
import AppSidebarItem from "@components/generic/sidebar/item/SidebarItem";
import jwtDecode from "jwt-decode";
import { redirectUtils } from "../../../../../packages/util/redirect/redirectUtils";


export default {
  components: {
    AppSidebarItem,
    MarketingPlanModal,
    SidebarToggle
  },

  data() {
    return {
      showingMarketingPlanModal: false,
      redirectUtils: redirectUtils
    };
  },
  mixins: [],

  props: {
    admin: {
      type: Object,
      required: true,
    },
  },

  computed: {
    canReadClientsdata() {
      return this.isMainAdmin ? true : this.adminPermissions.includes('READ_CLIENT_DATA')
    },
    adminDecodedToken() {
      return jwtDecode(this.admin.token)
    },
    isMainAdmin() {
      return this.adminDecodedToken.userId === -1
    },
    adminPermissions() {
      return this.adminDecodedToken.permissions
    }
  },

  methods: {
    
    openMarketingPlanModal() {
      this.showingMarketingPlanModal = true;
    },
  },
  
};
</script>

<style lang="scss" scoped>
 a {
   text-decoration: none;
}
</style>
